/**
 * WebRTC 屏幕分辨率检测模块。
 */

let resolutionDetectorHandler: ReturnType<typeof setInterval> | null;

/**
 * 从视频流中读取屏幕分辨率并缓存到 sessionStorage。
 */
export const settingScreenResolution = () => {
	const screenWrapper = document.getElementById("screenWrapper");

	if (screenWrapper != null) {
		//var el = document.createElement(event.track.kind)
		const mediaStream = (screenWrapper.firstChild as HTMLVideoElement | null)
			?.srcObject as MediaStream | null;

		if (mediaStream !== null) {
			const mediaStreamTrack = mediaStream.getTracks()[0];

			const settings = mediaStreamTrack.getSettings();

			const resolutionString = `${settings.width}x${settings.height}`;

			sessionStorage.setItem("device_resolution", resolutionString);

			console.log("setting screen resolution:", resolutionString);
		}
	}
};

/**
 * 周期性检查并刷新屏幕分辨率。
 */
export const autoCheckScreenResolution = () => {
	resolutionDetectorHandler = setInterval(() => {
		if (document.getElementById("screenWrapper") === null) {
			if (resolutionDetectorHandler) {
				clearInterval(resolutionDetectorHandler);
			}
		}
		settingScreenResolution();
	}, 1000);
};

/**
 * 初始化分辨率检测器，确保仅保留单一轮询。
 */
export const initResolutionChecker = () => {
	//PubSub.subscribe("peerConnection", (msg, data) => {
	//if (data === "closed") {
	if (resolutionDetectorHandler) {
		clearInterval(resolutionDetectorHandler);
	}
	//} else if (data === "connected") {
	autoCheckScreenResolution();
	//}
	// });
};
